/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminUpdateBranchDto,
  BranchDto,
} from '../models/index';
import {
    AdminUpdateBranchDtoFromJSON,
    AdminUpdateBranchDtoToJSON,
    BranchDtoFromJSON,
    BranchDtoToJSON,
} from '../models/index';

export interface UpdateBranchRequest {
    branchId: number;
    adminUpdateBranchDto: AdminUpdateBranchDto;
}

/**
 * 
 */
export class BranchServiceApi extends runtime.BaseAPI {

    /**
     */
    async getAllBranchesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BranchDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/branch`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BranchDtoFromJSON));
    }

    /**
     */
    async getAllBranches(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BranchDto>> {
        const response = await this.getAllBranchesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Updates branch (and optionally its contact info) by ID
     */
    async updateBranchRaw(requestParameters: UpdateBranchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BranchDto>> {
        if (requestParameters['branchId'] == null) {
            throw new runtime.RequiredError(
                'branchId',
                'Required parameter "branchId" was null or undefined when calling updateBranch().'
            );
        }

        if (requestParameters['adminUpdateBranchDto'] == null) {
            throw new runtime.RequiredError(
                'adminUpdateBranchDto',
                'Required parameter "adminUpdateBranchDto" was null or undefined when calling updateBranch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/branch/{branchId}`.replace(`{${"branchId"}}`, encodeURIComponent(String(requestParameters['branchId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AdminUpdateBranchDtoToJSON(requestParameters['adminUpdateBranchDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BranchDtoFromJSON(jsonValue));
    }

    /**
     * Updates branch (and optionally its contact info) by ID
     */
    async updateBranch(requestParameters: UpdateBranchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BranchDto> {
        const response = await this.updateBranchRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
